import { create } from 'zustand';

import type { BaseModalEntity } from './types';

interface ModalStore {
  showModal: (modalEntity: BaseModalEntity) => void;
  hideModal: () => void;
  modalEntity: BaseModalEntity | undefined;
}

const initialState = {
  modalEntity: undefined,
};

export const useModalStore = create<ModalStore>()((set) => ({
  ...initialState,
  showModal: (modalEntity) => set({ modalEntity }),
  hideModal: () => set({ modalEntity: undefined }),
}));
